export type PermissionAction =
  | 'read'
  | 'create'
  | 'update'
  | 'delete'
  | 'manage'
  | 'force'
  | 'file';

export type PermissionResource =
  | 'journal_entries'
  | 'reports'
  | 'tax'
  | 'sales_invoices'
  | 'purchase_invoices'
  | 'quotes'
  | 'contacts'
  | 'banks'
  | 'payments'
  | 'expenses'
  | 'business_setup'
  | 'business_users'
  | 'e_invoice'
  | 'settings'
  | 'ai'
  | 'payroll';

export interface PermissionGrant {
  resource: string;
  action: string;
}

/** Map primary nav paths to the RBAC resource that must be readable. */
export const ROUTE_PERMISSION_RESOURCE: Record<string, PermissionResource> = {
  '/contacts': 'contacts',
  '/bank-accounts': 'banks',
  '/invoices': 'sales_invoices',
  '/quotes': 'quotes',
  '/expenses': 'expenses',
  '/bulk-payments': 'payments',
  '/account-transfers': 'banks',
  '/transfers': 'banks',
  '/asp-operations': 'e_invoice',
  '/journal-entries': 'journal_entries',
  '/chart-of-accounts': 'journal_entries',
  '/reports': 'reports',
  '/tax-periods': 'tax',
  '/image-processing': 'ai',
  '/payroll': 'payroll',
  '/fixed-assets': 'journal_entries',
  '/settings': 'settings',
};

export function hasPermission(
  permissions: PermissionGrant[] | null | undefined,
  resource: PermissionResource | string,
  action: PermissionAction | string,
  opts?: { isSuperAdmin?: boolean }
): boolean {
  if (opts?.isSuperAdmin) return true;
  if (!permissions || permissions.length === 0) return false;
  return permissions.some(
    (p) => p.resource === resource && p.action === action
  );
}

export function canAccessRoute(
  permissions: PermissionGrant[] | null | undefined,
  path: string | undefined,
  opts?: { isSuperAdmin?: boolean }
): boolean {
  if (!path) return true;
  if (opts?.isSuperAdmin) return true;
  if (path === '/dashboard') return true;
  if (path.startsWith('/super-admin')) return Boolean(opts?.isSuperAdmin);

  const resource = ROUTE_PERMISSION_RESOURCE[path];
  if (!resource) return true;
  return hasPermission(permissions, resource, 'read', opts);
}
